import { Link } from "react-router-dom";
import { answerBlocks } from "../../lib/copilot";

// Renders an answer from a small, safe subset of Markdown (paragraphs, lists, tables, bold, links INSIDE Jamora): never raw HTML.
function Inline({ tokens, onNavigate }) {
  return tokens.map((token, index) => {
    if (token.type === "bold") return <strong key={index} className="font-semibold">{token.text}</strong>;
    if (token.type === "link") {
      return (
        <Link key={index} to={token.href} onClick={onNavigate} className="text-jamora font-medium underline underline-offset-2 hover:text-jamora-hover">
          {token.text}
        </Link>
      );
    }
    return <span key={index}>{token.text}</span>;
  });
}

export default function CopilotText({ text, onNavigate }) {
  return (
    <div className="space-y-2 text-sm leading-relaxed text-slate-800">
      {answerBlocks(text).map((block, index) => {
        if (block.type === "paragraph") return <p key={index}><Inline tokens={block.tokens} onNavigate={onNavigate} /></p>;
        if (block.type === "table") {
          return (
            <div key={index} className="overflow-x-auto rounded-lg border border-slate-200" data-testid="copilot-table">
              <table className="w-full border-collapse text-left text-sm">
                <thead className="bg-slate-50">
                  <tr>
                    {block.header.map((cell, i) => (
                      <th key={i} scope="col" className="whitespace-nowrap border-b border-slate-200 px-3 py-2 text-xs font-semibold text-slate-600">
                        <Inline tokens={cell} onNavigate={onNavigate} />
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {block.rows.map((row, r) => (
                    <tr key={r} className="border-b border-slate-100 last:border-0">
                      {row.map((cell, i) => (
                        <td key={i} className="px-3 py-2 align-top"><Inline tokens={cell} onNavigate={onNavigate} /></td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        }
        const List = block.type === "ordered" ? "ol" : "ul";
        return (
          <List key={index} className={`pl-5 space-y-1 ${block.type === "ordered" ? "list-decimal" : "list-disc"}`}>
            {block.items.map((item, i) => <li key={i}><Inline tokens={item} onNavigate={onNavigate} /></li>)}
          </List>
        );
      })}
    </div>
  );
}
